import { axiosCashJournalClient } from "./api";
import { MIDDLE_URL } from "./config";

export interface IResponsePostData {
  responseCode: "Succeed" | "Failed",
  responseMessage: string
}

export interface MetadataI {
  page: number,
  page_size: number,
  total_items: number,
  total_pages: number
}

interface IPostTrxWithdrawalPayload {
  trx_id: string, // string pake koma aja
  area_id: string,
  pool_id: string,
  company_code: string,
  company_relations: string,
  value_date: string, // YYYYMMDD
  trx_desc: string, // "keterangan"
  withdrawal_amount: number, // yg ditarik
  total_payment: number, // total bon
  requestor: string, // sama kayak create by
  ref_correction: string, // kosong dulu
  create_by: string,
}

interface GetTrxWithdrawalParamsI {
  area_id?: string,
  pool_id?: string,
  company_code?: string,
  company_relations?: string,
  search?: string,
  start_date?: string,
  end_date?: string,
  sort_by?: string,
  sort_type?: string,
  page_number?: number,
  page_size?: number,
}

export interface IGetWithdrawalData {
  id: number,
  trx_id: string,
  trx_type: string,
  code_type: string,
  area_id: string,
  pool_id: string,
  company_code: string,
  company_relations: string,
  code_segment: string,
  department: string,
  trx_date: string,
  trx_code: string,
  gnlldr: string,
  sap_shkzg: string,
  employee_id: string,
  employee_name: string,
  trx_text: string,
  amount: number,
  transfer_date: string,
  transfer_time: string,
  requestor: string,
  request_date: string,
  withdrawal_number: string,
  create_at: string,
  create_by: string,
  trx_desc: string
}

interface IGetTrxWithdrawalResponse {
  list_trx_withdrawal: IGetWithdrawalData[],
  metadata: MetadataI
}

interface GetTrxWithdrawalHistoryParamsI {
  search?: string,
  area_id?: string,
  pool_id?: string,
  code_type?: string,
  company_code?: string,
  company_relations?: string,
  period_date?: string,
  sort_by?: string,
  sort_type?: string,
  page_number?: number,
  page_size?: number,
}

export interface IGetWithdrawalHistoryData {
  withdrawal_number: string,
  code_type: string,
  area_id: string,
  pool_id: string,
  company_code: string,
  company_relations: string,
  value_date: string,
  trx_date: string,
  trx_desc: string,
  total_amount_bon: number,
  withdrawal_amount: number,
  cash_on_hand_balance: number,
  cash_on_hand_before_withdrawal: number,
  withdrawal_details: IGetWithdrawalData[]
}

interface IGetTrxWithdrawalHistoryResponse {
  list_trx_withdrawal_history: IGetWithdrawalHistoryData[],
  metadata: MetadataI
}

export interface IGetDetailTrxWithdrawalResponse {
  id: number,
  trx_id: string,
  trx_type: string,
  code_type: string,
  area_id: string,
  area_name: string,
  pool_id: string,
  company_code: string,
  company_relations: string,
  code_segment: string,
  segment_desc: string,
  department: string,
  trx_date: string,
  trx_code: string,
  gnlldr: string,
  trx_desc: string,
  sap_shkzg: string,
  trx_text: string,
  employee_id: string,
  employee_name: string,
  job_title: string,
  amount: number,
  transfer_date: string,
  transfer_time: string,
  requestor: string,
  request_date: string,
  withdrawal_number: string,
  bank_accounts: {
    vendor_code: string,
    vendor_name: string,
    vendor_address: string,
    bank_account: string,
    bank_name: string,
    bank_account_number: string,
    bank_account_name: string
  },
  list_files: {
    id: number,
    trx_id: string,
    item_id: number,
    file_name: string,
    path_file: string,
    source_file: string,
    source_key: string,
    file_size: string,
    create_at: string,
    create_by: string
  }[],
  create_at: string,
  create_by: string
}

export interface IGetCashOnHandResponse {
  code_type?: string,
  area_id?: string,
  pool_id?: string,
  company_code?: string,
  company_relations?: string,
  ending_balance?: string,
  create_at?: string,
  create_by?: string,
  update_at?: string,
  update_by?: string,
  maximal_cashonhand?: {
    max_coh?: number,
    is_default?: boolean,
    expired_date?: string
  }
}
interface GetWithdrawalDocI {
  pool_id: string,
  area_id?: string,
  company_code: string,
  company_relations?: string,
  period_month_year: string,
  code_type: string,
}
export interface GetWithdrawalDocResponseI {
  response_code: "Succeed" | "Failed",
  response_message: string,
  file_dentity?: {
    file_name: string,
    file_path: string,
    content_type: string,
    bucket_name: string,
    file_url: string,
    folder_name: string
  }
}

export const url = "/v1/smpltrxwithdrawal";

export const postTrxWithdrawal = async (
  payload: IPostTrxWithdrawalPayload,
): Promise<IResponsePostData> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}`,
    method: "POST",
    data: payload,
  });

  return data;
};

export const getTrxWithdrawal = async (
  payload?: GetTrxWithdrawalParamsI,
): Promise<IGetTrxWithdrawalResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}`,
    method: "GET",
    params: payload,
  });

  return data;
};

export const getDetailTrxWithdrawal = async (
  id: string,
): Promise<IGetDetailTrxWithdrawalResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}/${id}`,
    method: "GET",
  });

  return data;
};

export const getTrxWithdrawalHistory = async (
  payload?: GetTrxWithdrawalHistoryParamsI,
): Promise<IGetTrxWithdrawalHistoryResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}/history`,
    method: "GET",
    params: payload,
  });

  return data;
};

export const getCashOnHand = async (
  poolId: string,
  areaId: string,
  companyCode: string,
  companyRelation?: string,
): Promise<IGetCashOnHandResponse> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}/cash-on-hand/${poolId}/${areaId}/${companyCode}${companyRelation ? `?company_relations=${companyRelation}` : ""}`,
    method: "GET",
  });

  return data;
};

export const getWithdrawalDoc = async (
  payload: GetWithdrawalDocI,
): Promise<GetWithdrawalDocResponseI> => {
  const { data } = await axiosCashJournalClient({
    url: `${MIDDLE_URL}${url}/history-export/excel/withdrawal`,
    method: "GET",
    params: payload,
  });

  return data;
};
